module.exports = __webpack_public_path__ + "images/tile-birthday-8fb3228cea1b5c54a3a605a4b63efe69.png";